import { useLingui } from "@lingui/react";
import { formatNumber } from "@mobility-item-page/utilities";
import { useAppConfig } from "../../../context/AppConfigProviderContext.tsx";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const InteriorSize = ({ interiorSize }: SpecProps<"interior_size">) => {
  const { i18n } = useLingui();
  const { locale } = useAppConfig();

  if (!interiorSize) {
    return null;
  }

  const length = i18n.t({
    id: "itemPageLayout.keyInfo.interiorSize.length",
    message: "Interior length",
    comment: "Field for 'Interior length' for bus and truck in ad specification",
  });
  const lengthValue = i18n.t({
    id: "itemPageLayout.common.length.value",
    message: "{length} cm",
    comment: "Length incl. postfix in cm",
    values: {
      length: formatNumber(interiorSize.length, locale),
    },
  });

  const width = i18n.t({
    id: "itemPageLayout.keyInfo.interiorSize.width",
    message: "Interior width",
    comment: "Field for 'Interior width' for bus and truck in ad specification",
  });
  const widthValue = i18n.t({
    id: "itemPageLayout.common.length.value",
    message: "{length} cm",
    comment: "Length incl. postfix in cm",
    values: {
      length: formatNumber(interiorSize.width, locale),
    },
  });

  const height = i18n.t({
    id: "itemPageLayout.keyInfo.interiorSize.height",
    message: "Interior height",
    comment: "Field for 'Interior height'for bus and truck in ad specification",
  });
  const heightValue = i18n.t({
    id: "itemPageLayout.common.length.value",
    message: "{length} cm",
    comment: "Length incl. postfix in cm",
    values: {
      length: formatNumber(interiorSize.height, locale),
    },
  });

  return (
    <>
      {interiorSize.length && <FieldValuePair field={length} value={lengthValue} />}
      {interiorSize.width && <FieldValuePair field={width} value={widthValue} />}
      {interiorSize.height && <FieldValuePair field={height} value={heightValue} />}
    </>
  );
};
